import { handleActions } from 'redux-actions';

export const defaultApartmentData = {
	id: -1,
	name: '',
	type: 'CO_LIVING',
	status: 'COMING_SOON',
	publishStatus: 'DELETE',
	content: '',
	mrt: '',
	cleanService: '',
	trashService: '',
	room: 0,
	kitchen: 0,
	balcony: 0,
	pet: 0,
	publicBath: 0,
	pingNumber: 0,
	floor: 0,
	elevator: 0,
	address: '',
	mrtWalkTime: 0,
	doorPassword: '',
	wifiName: '',
	wifiPassword: '',
	taxId: '',
	electricNumber: '',
	waterNumber: '',
	gasNumber: '',
	networkNumber: '',
	latitude: -21.58704,
	longitude: 59.228986,
	remarks: '',
	createdAt: '2018-06-19 16:43:20',
	updatedAt: '2018-06-19 16:43:20',
	owners: [],
	photos: [],
	tags: [],
	rooms: [],
	mrtData: {
		id: 95,
		name: '龍山寺',
		name_en: 'Longshan Temple',
		line: '板橋南港',
		line_en: 'Bannan',
		near_station: '西門,江子翠',
		near_station_en: 'Ximen,Jianzicui',
		created_at: '2018-10-12 18:43:06',
		updated_at: '2018-10-12 19:01:14',
	},
	cityData: null,
	districtData: null,
};

export default handleActions(
	{
		FETCH_APARTMENT_FULFILLED: (state, action) => ({
			...state,
			list: action.payload.list,
			data: action.payload.data,
		}),

		UPDATE_APARTMENT: (state, action) => ({
			...state,
			data: {
				...state.data,
				...action.payload,
			},
		}),

		FETCH_APARTMENT_BY_ID_FULFILLED: (state, action) => ({
			...state,

			recommend: action.payload.recommend,
		}),

		FETCH_COLLECT_FULFILLED: (state, action) => ({
			...state,

			data: {
				...state.data,
				...action.payload.apartmentData,
			},
		}),
	},
	{
		list: [],
		data: {},
		recommend: [],
		currentPage: 0,
		lastPage: 0,
		perPage: 0,
		total: 0,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/apartment.js